import { getMany2manyDiff, Recipe as RecipeGraphql } from '@akin-home/amplify';
import { postImageToCloud } from '@akin-home/images/frontend';
import { createRecordOptionMutation } from '@akin-home/options/frontend';
import { Recipe } from '@akin-home/recipes';
import { getIDs } from '@akin-home/records';
import { createRecipeMutation } from '../api/mutations';
import { getRecipeQuery } from '../api/queries';
import { recipeModelToCreateRecipeInput } from './index';

export const createRecipeFromModel = async (
  recipe: Recipe
): Promise<RecipeGraphql> => {
  const readGroups = recipe.habitatID ? undefined : ['common'];

  const recipeToPost: Recipe = {
    ...recipe,
    readGroups,
  };

  if (recipe.imageUpload) {
    recipeToPost.image = await postImageToCloud({
      habitatID: recipe.habitatID,
      readGroups,
      file: recipe.imageUpload,
    });
  }

  const {
    data: { createRecipe },
  } = await createRecipeMutation({
    input: recipeModelToCreateRecipeInput(recipeToPost),
  });

  const recipe_id = createRecipe?.id;

  if (!recipe_id) {
    throw Error('Failed to creat recipe');
  }

  const { toCreate: specialDietsToCreate } = getMany2manyDiff(
    getIDs(recipeToPost.specialDiets, undefined),
    recipeToPost.specialDietM2mItems
  );

  // Many2many records to create
  if (specialDietsToCreate.length) {
    await Promise.all(
      specialDietsToCreate.map((optionID: string) => {
        createRecordOptionMutation({
          input: { recordID: recipe_id, optionID },
        });
      })
    );
  }

  return (await (
    await getRecipeQuery({ id: recipe_id })
  ).data.getRecipe) as RecipeGraphql;
};
